module.exports = __webpack_public_path__ + "media/svg/selected-7e8221f3.svg";